import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "../tableComponent";
import config from '../../config'

class Component extends TableComponent {

  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day')
  }

  makeColumns = () => {
    var columns = [
      {
        Header: "Mid",
        accessor: "support_site",
        Cell: ({ original }) =>
          <div>
            <div>{original.support_site}</div>
          </div>,
        minWidth: 40, 
        Footer: props => <b>Total:</b>       
      }, {
        Header: "Sales",
        accessor: "sales",
        Cell: ({ original }) =>
          <div>
            <div>{original.sales || 0}</div>
          </div>,
        minWidth: 50,        
        Footer: props => 
          <span>{this.props.total.sales || 0} ($ {this.props.total.paid || 0} paid)</span>
      }, {
        Header: "Auth",
        accessor: "auth",
        Cell: ({ original }) =>
          <div>
            <div>{Math.round(original.auth || 0)}</div>
          </div>,
        minWidth: 50,        
        Footer: props => 
          <span>{Math.round(this.props.total.auth || 0)} ($ {Math.round((this.props.total.auth || 0)*39.95)} pending)</span>
      }, {
        Header: "Earned",
        accessor: "earned",
        Cell: ({ original }) =>
          <div>
            <div>$ {Math.round(original.earned)}</div>
          </div>,
        minWidth: 60,        
        Footer: props => 
          <span>$ {Math.round(this.props.total.earned || 0)} ($ {Math.round((this.props.total.earned || 0) - (this.props.total.paid || 0))} profit)</span>
      }, {
        Header: "Refunded",
        accessor: "refunded",
        Cell: ({ original }) =>
          <div>
            <div>$ {Math.round(original.refunded || 0)}</div>
          </div>,
        minWidth: 40,        
        Footer: props => 
          <span>$ {Math.round(this.props.total.refunded || 0)}</span>
      }, {
        Header: "Chargebacks",
        accessor: "chargebacks",
        Cell: ({ original }) =>
          <div>
            <div>$ {Math.round(original.chargebacks || 0)}</div>
          </div>,
        minWidth: 40,        
        Footer: props => 
          <span>$ {Math.round(this.props.total.chargebacks || 0)}</span>
      }
    ]
    return columns; 
  }

  apiPath = "hookupbay/mids"
  editApiPath = "hookupbay/update_mid"

  tableParams = {
    manual: true,
    sorted: [{
      id: "mid",
      desc: true
    }],
    showAll: false
  }

  render() {
    return (
      <div>
        {!this.props.state.initial &&         
        
        <div>   
          <div class="row table-head-controls">
            <div class="col-10">
              {this.datepickerElement()}              
            </div>
          </div>
        </div>
        }
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"hookupbay_mids")